// extracted by mini-css-extract-plugin
module.exports = {"TabContainer":"Tabs_TabContainer__jUxa_","Tabs":"Tabs_Tabs__1tYeb","Tab":"Tabs_Tab__2QBlu","Mui-selected":"Tabs_Mui-selected__YsIqr"};